import * as React from 'preact/compat'
import type { GameInfo } from '../SeriesEditor/types'
import type { Coords } from './SeriesSchemeRenderer'
import GameRenderer from './GameRenderer'
import styles from '../../../css/game-series-scheme.pcss.json'

interface PropTypes {
  gamesInfo: Array<{
    game: GameInfo,
    coords: Coords
  }>,
}

export default class SeriesTableRenderer extends React.Component<PropTypes, any> {

  xMin = 0
  xMax = 0
  yMin = 0
  yMax = 0

  constructor(props: PropTypes) {
    super(props)
    this.prepareTable()
  }

  prepareTable = () => {
    this.props.gamesInfo.forEach(({ coords }) => {
      if (coords.x < this.xMin) {
        this.xMin = coords.x
      }
      if (coords.x > this.xMax) {
        this.xMax = coords.x
      }
      if (coords.y < this.yMin) {
        this.yMin = coords.y
      }
      if (coords.y > this.yMax) {
        this.yMax = coords.y
      }
    })
  }

  renderCell = (x: number, y: number) => {
    const cellGames = this.props.gamesInfo.filter(game => {
      return game.coords.x === x && game.coords.y === y
    }).sort((game1, game2) => {
      return game1.game.release_date < game2.game.release_date ? -1 : game1.game.release_date > game2.game.release_date ? 1 : 0
    })

    return <div className={styles['cell']}>
      {cellGames.map(item => <GameRenderer game={item.game}/>)}
    </div>
  }

  renderCells = () => {
    const cells = []
    for (let y = this.yMin; y <= this.yMax; y++) {
      for (let x = this.xMin; x <= this.xMax; x++) {
        cells.push(this.renderCell(x, y))
      }
    }
    return cells
  }

  render() {
    return <div
      className={styles['innerChartContainer']}
      style={{
        gridTemplateColumns: `repeat(${this.xMax - this.xMin + 1}, 1fr)`
      }}
    >
      {this.renderCells()}
    </div>
  }
}
